import React, { Component } from 'react';
import styled from 'styled-components';
import { Button } from '@zocdoc-frontend-common/components-button';
import { blue100 } from '@zocdoc-mezzanine/foundations-colors';

const PartialButton = styled(Button)`
    display: inline-block;
    border-top: none;
    border-right: none;
    box-sizing: border-box;
    width: 33.33%;

    &:hover {
        border-top: none;
        border-right: none;
    }

    &:last-child {
        border-right: 1px solid ${blue100};

        &:hover {
            border-right: 1px solid ${blue100};
        }
    }
`;

/**
 * @param {string} googleUrl
 * @param {string} iCalUrl
 * @param {function(): void} onAddToCalendarClick
 * @param {function(): void} onGoogleClick
 * @param {function(): void} onIcalClick
 * @param {function(): void} onOutlookClick
 * @param {string} outlookUrl
 * @returns {JSX.Element}
 * @constructor
 */
export class AddToCalendar extends Component {
    state = {
        showLinks: false,
    };

    toggleLinks = () => {
        this.setState({
            showLinks: !this.state.showLinks,
        });

        this.props.onAddToCalendarClick();
    };

    renderCalendarLinks(showLinks) {
        if (showLinks) {
            return (
                <div>
                    <PartialButton
                        data-test="outlook-button"
                        href={this.props.outlookUrl}
                        onClick={this.props.onOutlookClick}
                        variation="btn-trans"
                    >
                        Outlook
                    </PartialButton>
                    <PartialButton
                        data-test="ical-button"
                        href={this.props.iCalUrl}
                        onClick={this.props.onIcalClick}
                        variation="btn-trans"
                    >
                        iCal
                    </PartialButton>
                    <PartialButton
                        data-test="google-button"
                        href={this.props.googleUrl}
                        onClick={this.props.onGoogleClick}
                        variation="btn-trans"
                    >
                        Google
                    </PartialButton>
                </div>
            );
        } else {
            return undefined;
        }
    }

    render() {
        return (
            <div>
                <Button
                    data-test="add-to-calendar-button"
                    fluid
                    onClick={this.toggleLinks}
                    variation="btn-trans"
                >
                    Add to Calendar
                </Button>
                {this.renderCalendarLinks(this.state.showLinks)}
            </div>
        );
    }
}
